import { schedulerService } from '../services/schedulerService';

const state = {
  meetings: []
};

const mutations = {
  setMeetings(state, meetings) {
    state.meetings = meetings
  },
};

const actions = {
  async fetchMeetings({ commit }, { start, end, staff_uids }) {
    try {
      let meetings = await schedulerService.fetchMeetings(start, end);
      commit('setMeetings', meetings)

    } catch (e) {
      console.error(e)
      return Promise.reject(e)
    }
  }
}

const getters = {
  allMeetings: (state) => state.meetings,
}


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
